import { Link } from 'react-router';

import { EmptyState } from '~/components/EmptyState.tsx';
import { useT } from '~/i18n/index.tsx';

/**
 * A URL that names nothing.
 *
 * The same empty state every list uses when it has nothing to show, rather than a bare sentence
 * and a stray button: whoever is here mistyped an address or followed a stale link, and the panel
 * should look like itself while saying so.
 *
 * No page-identity card above it. That card names the section you are in, and the whole point of
 * this screen is that there is no section — printing the same sentence twice, once as a title and
 * once as the answer, only made the repetition visible.
 */
export function NotFoundPage() {
  const t = useT();

  return (
    <EmptyState
      icon="search"
      title={t('common.notFound')}
      hint={t('common.notFoundHint')}
      action={
        <Link className="awj-button awj-button--secondary" to="/">
          {t('common.backToDashboard')}
        </Link>
      }
      tall
    />
  );
}
